import { reducer } from "ts-action";
import { on } from "ts-action-immer";
import * as AC from "../actionCreators";
import { DataSourceId } from "../../../globalTypes";

export type State = DataSourceId[];

const initialState: State = [];

const idsOfCheckingDatasourcesReducer = reducer(
  initialState,
  on(AC.checkMappingRequest, (state, action) => {
    const { datasourceId } = action.payload;
    return [...new Set([...state, datasourceId])];
  }),
  on(AC.checkMappingResponse, AC.checkMappingError, (state, action) => {
    const { datasourceId } = action.payload;
    return state.filter((id) => id !== datasourceId);
  })
);

export default idsOfCheckingDatasourcesReducer;
export type IdsOfCheckingDatasourcesState = State;
